import { accountApi } from "./accountApi";
import { actionIdentifiersApi } from "./actionIdentifiersApi";
import { agronomistInvoicingApi } from "./agronomistInvoicingApi";
import { alertsApi } from "./alertsApi";
import { actionsApi } from "./actionsApi";
import { authApi } from "./authApi";
import { biocycleApi } from "./biocycleApi";
import { chartsApi } from "./chartsApi";
import { chatApi } from "./chatApi";
import { chatbotApi } from "./chatbotApi";
import { collabApi } from "./collabApi";
import { groupsApi } from "./groupsApi";
import { cropsApi } from "./cropsApi";
import { emissionsApi } from "./emissionsApi";
import { enemiesApi } from "./enemiesApi";
import { equipmentsApi } from "./equipmentsApi";
import { fieldAnalysisApi } from "./fieldAnalysisApi";
import { fieldsApi } from "./fieldsApi";
import { filtersApi } from "./filtersApi";
import { generalAgroApi } from "./generalAgroApi";
import { inboxApi } from "./inboxApi";
import { invoicesApi } from "./invoicesApi";
import { kaekApi } from "./kaekApi";
import { labelsApi } from "./labelsApi";
import { legalEntitiesApi } from "./legalEntitiesApi";
import { messagesApi } from "./messagesApi";
import { newsFeedApi } from "./newsFeedApi";
import { opekepeApi } from "./opekepeApi";
import { paymentsApi } from "./paymentsApi";
import { satelliteApi } from "./satelliteApi";
import { settingsApi } from "./settingsApi";
import { stressesApi } from "./stressesApi";
import { supersetApi } from "./supersetApi";
import { teamsApi } from "./teamsApi";
import { usersApi } from "./usersApi";
import { weatherApi } from "./weatherApi";

const endpoints = {
  account: accountApi,
  agronomistInvoicing: agronomistInvoicingApi,
  alerts: alertsApi,
  actions: actionsApi,
  actionIdentifiers: actionIdentifiersApi,
  auth: authApi,
  biocycle: biocycleApi,
  charts: chartsApi,
  chat: chatApi,
  chatbot: chatbotApi,
  collab: collabApi,
  groups: groupsApi,
  crops: cropsApi,
  emissions: emissionsApi,
  enemies: enemiesApi,
  equipments: equipmentsApi,
  fieldAnalysis: fieldAnalysisApi,
  fields: fieldsApi,
  filters: filtersApi,
  inbox: inboxApi,
  invoices: invoicesApi,
  labels: labelsApi,
  legalEntities: legalEntitiesApi,
  opekepe: opekepeApi,
  payments: paymentsApi,
  generalAgro: generalAgroApi,
  kaek: kaekApi,
  messages: messagesApi,
  newsFeed: newsFeedApi,
  satellite: satelliteApi,
  settings: settingsApi,
  stresses: stressesApi,
  superset: supersetApi,
  teams: teamsApi,
  users: usersApi,
  weather: weatherApi,
};

export default endpoints;
